import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {DxNavigationTreeNode} from "../../../../../domain/navigator/dx-navigation-tree-node";

@Component({
  selector: 'dx-head-dropdown-panel',
  templateUrl: './dx-head-dropdown-panel.component.html',
  styleUrls: ['./dx-head-dropdown-panel.component.css']
})
export class DxHeadDropdownPanelComponent implements OnInit, OnDestroy {
  /** Узел первого уровня навигационного меню, являющийся корнем ветки для данного пункта */
  private _menuNode: DxNavigationTreeNode;

  /** @constructor */
  constructor() {}

  ngOnInit(): void { }

  ngOnDestroy(): void { }

  @Input()
  set menuNode(value: DxNavigationTreeNode) {
    this._menuNode = value;
  }
}
